export default __webpack_public_path__ + "static/media/gallery_16.c8b5a088.jpg";